import React from 'react';
import cn from 'classnames';
import { price } from '../../utils/format';
const BriefDeliveryRoom = ({
  value,
  room,
  prices,
  removable = false,
  onChange,
  onRemove,
  multiroomDiscount,
}) => {
  const selected = value[room.value] && value[room.value].term;
  const onChangePlan = function(newTermsId) {
    const p = prices[room.name] && prices[room.name].terms.find(p => p.id === newTermsId);
    p && onChange(room, p);
  };

  function priceById() {
    const filteredPricesById = prices[room.name].plans.find(p => p.id === 'y2023').price;
    return filteredPricesById; 
  };

  const filteredPrices = priceById();

  return (
    <div className={cn('brief_delivery-section')}>
      <div className="brief_delivery-section-title">
        {room.label}: <span className={multiroomDiscount ? '-old-price' : ''}>£{filteredPrices}</span>
        {multiroomDiscount && (
          <span className="-sale-price">&nbsp; £{filteredPrices - 50}</span>
        )}
      </div>
      <div className="brief_delivery-grid">
        <div className="plate-select-grid">
          {prices[room.name] &&
            prices[room.name].terms.map(plan => (
              <div className={cn('plate-select-grid_item -half-width -half-width-mobile')} key={`${plan.id}`}>
                <div className={cn('plate-select')}>
                  <input
                    className="plate-select_input"
                    type="radio"
                    name={`${room.value}-term`}
                    id={`${room.value}-${plan.id}`}
                    value={plan.id}
                    defaultChecked={value[room.value] && value[room.value].term === plan.id}
                    onChange={e => {
                      onChangePlan(e.target.value);
                    }}
                  />
                  <label className="plate-select_label"
                         htmlFor={`${room.value}-${plan.id}`}
                  >
                    <div className="plate-select_icons-wrapper">
                      <div className="plate-select_icons">
                        <svg className={`plate-select_icon -delivery-${plan.id}`}>
                          <use xlinkHref={`#icon_delivery-${plan.id}`} xmlnsXlink="http://www.w3.org/1999/xlink" />
                        </svg>
                      </div>
                    </div>
                    <div className="plate-select_title">
                      {plan.id === 'normal' ? 'Standard' : 'Express'}
                    </div>
                    <div className="plate-select_text">
                      {plan.price > 0 ? '+ ':''}£{plan.price}
                    </div>
                  </label>
                  <div className={`plate-select_hint ${plan.id === 'normal' ? '' : '-bold'}`}>
                    {plan.id === 'normal' ? '3 weeks' : '10 days'}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default BriefDeliveryRoom;



// WEBPACK FOOTER //
// ./app/javascript/components/brief/components/BriefDelivery/BriefDeliveryRoom.js